import styled from 'styled-components';

import { Button } from 'shared/presentation/components/molecules';

export const Container = styled(Button)`
  border: 1px solid ${props => props.theme.palette.neutral[300]};
`;
